import { axiosBase } from "api/aBase"

export default function useUserApi() {
  async function contactUs(data) {
    try {
      const response = await axiosBase.post("user/contact-us", data)
      console.log({response});
      
      return response.data
    } catch (err) {
      return err.response.data
    }
  }

  return {
    contactUs,
  }
}
